import { Box, Container, Grid, Typography } from "@mui/material"
import { hasRole } from "auth/hasRole"
import { useApiPut } from "auth/useApi2"
import { useApi } from "auth/useApi3"
import { AppContext } from "components/AppContextProvider"
import SubTabs from "components/SubTabs"
import { ClpTableEnum } from "components/ClpTable/ClpTableEnum"
import { PageTabs } from "components/navigation/PageTabs/PageTabs"
import { useQuery } from "components/useQuery"
import { apiEndpoints } from "generated/apiEndpoints"
import { allRoles } from "generated/roles"
import { allRoutes } from "generated/routes"
import moment from "moment"
import { useCallback, useContext, useEffect, useState } from "react"
import Moment from "react-moment"
import Header from "shared/vehicle/Header"
import LoadingHeader from "shared/vehicle/components/LoadingHeader"
import LoadingTabs from "shared/vehicle/components/LoadingTabs"
import { VehicleForm } from "../../components/VehicleList/VehicleForm"
import { useTranslation } from "react-i18next"
import VehicleSwiper from "components/VehicleSwiper/VehicleSwiper"
import DetailsTabPanel from "./components/DetailsTabPanel"

const getNavigationHistoryData = (navigationHistory, t) => {
  const backButtonData = {
    "/vehicleregistry/vehicles": {
      text: `${" "}${t("global.to", "to")} ${t("global.the_vehicleregister", "Vehicle register")}`,
      path: "/vehicleregistry/vehicles"
    },
    "/vehicleregistry/checks": {
      text: `${" "}${t("global.to", "to")} ${t("global.checks", "Checks")}`,
      path: "/vehicleregistry/checks"
    },
    "/vehicleregistry/calendar": {
      text: `${" "}${t("global.to", "to")} ${t("app.tabs.titles.vehicleregistry_calendar", "Calendar")}`,
      path: "/vehicleregistry/calendar"
    },
    "/reports/vehiclereports": {
      text: `${" "}${t("global.to", "to")} ${t("global.features.title.vehicleregistry_reports", "Reports")}`,
      path: "/reports/vehiclereports"
    },
    "/issuereports/archive": {
      text: `${" "}${t("global.to", "to")} ${t(
        "app.tabs.titles.issuereports_issuereports",
        "Issue reports"
      )}`,
      path: "/issuereports/archive"
    },
    "/issuereports/workorders": {
      text: `${" "}${t("global.to", "to")} ${t("app.tabs.titles.issuereports_workorder", "Work orders")}`,
      path: "/issuereports/workorders"
    },
    "/vehiclealarm": {
      text: `${" "}${t("global.to", "to")} ${t("app.tabs.titles.vehiclealarm", "Vehcile alarm")}`,
      path: "/vehiclealarm"
    }
  }

  if (navigationHistory.length < 2) {
    return null
  }

  const historyIndex = navigationHistory.length - 2
  const previousPath = navigationHistory[historyIndex].path

  if (backButtonData[previousPath]) {
    return backButtonData[previousPath]
  }

  return null
}

const ViewOption = {
  Upcoming: "Upcoming",
  History: "History"
}

const getViewList = (t) => {
  return [
    { value: ViewOption.Upcoming, label: t("global.upcoming", "Upcoming") },
    { value: ViewOption.History, label: t("global.history", "History") }
  ]
}

function endpointFilter(latestHistory) {
  for (let i = 0; i < latestHistory.length; i++) {
    const element = latestHistory[i];
    if (element.path.includes("details")) continue
    if (element.path === "/vehicleregistry/vehicles") return true
    return false
  }
  return false
}

const VehicleDetails = ({ match }) => {
  const { t } = useTranslation()
  const [detailsResult, detailsFuncs] = useApi()
  const appContext = useContext(AppContext)
  const urlQuery = useQuery()
  const [tabValue, setTabValue] = useState(0)
  const isIssueReports = hasRole(appContext.appUser, allRoles.IssueReports)
  const [addOrUpdateResultState, setAddOrUpdateResultState] = useState(null)
  const [mainPropellantResult, mainPropellantApi] = useApi()
  const [customFieldsResult, customFieldsApi] = useApi()
  const [lastUpdatedVtrResult, lastUpdatedVtrApi] = useApi()
  const [assemblyResult, assemblyApi] = useApi()
  const [vehiclesResult, vehiclesApi] = useApi()
  const [clpTableFilterResult, clpTableFilterApi] = useApi()
  const [vehicleExistsInFiltered, setVehicleExistsInFiltered] = useState(false)
  const viewList = getViewList(t)
  const [view, setView] = useState(viewList[0].value)
  const [updateVehicleResult, updateVehicle] = useApiPut()
  const [vehiclesList, setVehiclesList] = useState([])

  const [tabs, setTabs] = useState([
    { index: 0, label: t("vehicleregistry.basic_info", "Basic info"), queryParam: "basics" },
    { index: 1, label: t("vehicleregistry.technical_data", "Technical data"), queryParam: "technicaldata" },
    { index: 2, label: t("vehicleregistry.custom_fields", "Custom fields"), queryParam: "customfields" },
    {
      index: 3,
      label: t("global.checks", "Checks"),
      queryParam: "checks"
    },
    { index: 4, label: t("documents.title", "Documents"), queryParam: "documents" },
    { index: 5, label: t("vehicleregistry.costs", "Costs"), queryParam: "expenses" }
  ])

  const navHistory = appContext?.navigationHistory.toReversed();
  const requiresFilter = endpointFilter(navHistory)

  const getAll = () => {
      vehiclesApi.post(apiEndpoints.vehicleregistry.getfiltered,[])
    }

  const getFilters = () => {
    clpTableFilterApi.get(`${apiEndpoints.clptableuserfilter.get}?clpTableId=${ClpTableEnum.VehicleRegistryVehicles}`)
  }

  useEffect(() => {
    if (isIssueReports) {
      setTabs((prevTabs) => [
        ...prevTabs,
        { index: 6, label: t("issuereports.issuereports", "Issue reports"), queryParam: "issuereports" }
      ])
    }
  }, [isIssueReports])

  useEffect(() => {
      if (!requiresFilter) {
      getAll()
    } else {
      getFilters()
    }
  }, [match.params.id])

  //Set all
  useEffect(() => {
    if (vehiclesResult.status !== 2) return
    setVehiclesList(vehiclesResult?.data.map((d) => d.vehicle))
  }, [vehiclesResult])

  //Get filtered data
  useEffect(() => {
    if (clpTableFilterResult.status !== 2) return
      vehiclesApi.post(apiEndpoints.vehicleregistry.getfiltered,clpTableFilterResult?.data?.columnFilters)
  }, [clpTableFilterResult])

  //Set filtered data
  useEffect(() => {
    if (vehiclesResult.status !== 2) return
    if (clpTableFilterResult.status !== 2) return
    const isInResult = vehiclesResult?.data?.findIndex((entry) => parseInt(entry.vehicle.id, 10) === parseInt(match.params.id, 10)) > -1
    if (isInResult) {
      setVehiclesList(vehiclesResult?.data.map((d) => d.vehicle))
    } else {
      vehiclesApi.post(apiEndpoints.vehicleregistry.getfiltered,[])
    }
  }, [clpTableFilterResult])

  const getCustomFields = useCallback( (vehicleId) => {
    customFieldsApi.get(
      apiEndpoints.vehicleregistry.getvehicleformvaluesfilteredbygroups.replace(
        "{vehicleId}",
        vehicleId
      )
    )
    return () => {
      customFieldsApi.reset()
    }
  }, [match.params.id])

  useEffect(() => {
    detailsFuncs.get(apiEndpoints.vehicleregistry.getvehicledetailsbyid.replace("{id}", match.params.id))
  }, [match.params.id])

  useEffect(() => {
    if (updateVehicleResult.status === 2) {
      detailsFuncs.get(apiEndpoints.vehicleregistry.getvehicledetailsbyid.replace("{id}", match.params.id))
      customFieldsApi.get(
        apiEndpoints.vehicleregistry.getvehicleformvalues.replace("{vehicleId}", match.params.id)
      )
      appContext.toggleSideBar(false)
    }
    setAddOrUpdateResultState(updateVehicleResult)
  }, [detailsFuncs, match.params.id, updateVehicleResult, customFieldsApi])

  useEffect(() => {
    if (clpTableFilterResult.status !== 2) return
    if (clpTableFilterResult.data.columnFilters.length === 0) {
      setVehicleExistsInFiltered(false)
    } else {
      setVehicleExistsInFiltered(true)
    }
  }, [vehiclesResult])

  useEffect(() => {
    lastUpdatedVtrApi.get(apiEndpoints.vehicleregistry.getlastupdatefromtransportagency)
    return () => {
      lastUpdatedVtrApi.leave()
    }
  }, [lastUpdatedVtrApi])

  useEffect(() => {
    if (isIssueReports && detailsResult.status === 2) {
      const assemblyUrl = apiEndpoints.assembly.getassemblydetails
        .replace("{regnr}", detailsResult?.data?.regNumber)
      assemblyApi.get(assemblyUrl)
    }
  }, [isIssueReports, detailsResult, assemblyApi])

  useEffect(() => {
    const tabParam = urlQuery.get("tab")
    if (!tabParam) return
    tabs.find((tab) => {
      if (tab.queryParam === tabParam.toLowerCase()) {
        setTabValue(tab.index)
        return true
      }
    })
  }, [urlQuery])

  const onSubmit = (values) => {
    updateVehicle(apiEndpoints.vehicleregistryadmin.updatevehicle, values)
  }

  const openForm = (row) => {
    setAddOrUpdateResultState(null)
    appContext.toggleSideBar("VehicleList", true)
  }

  const backButton = getNavigationHistoryData(appContext?.navigationHistory, t)

  return (
    <Box marginBottom={8}>
      <PageTabs
        routeBack
        tabs={[
          {
            path: backButton?.path || allRoutes.VehicleregistryVehicles(),
            title: t("global.back", "Back") + (backButton?.text || "")
          }
        ]}
      />
      {hasRole(appContext.appUser, allRoles.VehicleRegistryAdmin) && (
        <VehicleForm
          vehicleResult={detailsResult}
          mainPropellantResult={mainPropellantResult}
          mainPropellantApi={mainPropellantApi}
          onSubmit={onSubmit}
          editMode={true}
          addOrUpdateResultState={addOrUpdateResultState}
        />
      )}
      <Container>
        <VehicleSwiper
          toolTipText={
            vehicleExistsInFiltered === true
              ? t(
                  "vehicleregistry.you_are_now_browsing_between_vehicles",
                  "You are now browsing between vehicles in your saved filter."
                )
              : t("vehicleregistry.you_browse_between_all_vehicles", "You browse between all vehicles")
          }
          loadingState={detailsResult.status}
          vehicleDetails={detailsResult.status === 2 ? detailsResult.data : []}
          vehiclesList={vehiclesList}
        />
      {detailsResult.status === 2 ? (
        <>
          <Box pb={2}></Box>
          <Header status={detailsResult.status} headerData={detailsResult.data} openForm={openForm} />
          <Box mt={3} />
          <SubTabs tabs={tabs} value={tabValue} setValue={setTabValue} marginLeft={1} />
          <Grid container direction="row">
            <Grid item xs={12} md={12} lg={12}>
              <DetailsTabPanel
                tabValue={tabValue}
                detailsResult={detailsResult}
                match={match} tabs={tabs}
                assemblyData={assemblyResult}
                customFieldsResult={customFieldsResult}
                isIssueReports={isIssueReports}
                viewList={viewList}
                view={view}
                viewOption={ViewOption}
                setView={setView}
                getCustomFields={getCustomFields}
              />
            </Grid>
          </Grid>
          {lastUpdatedVtrResult.status === 2 && (
            <Typography variant="caption">
              {t("vehicleregistry.transport_board_data_from", "Transport Board data from")}:{" "}
              {moment(lastUpdatedVtrResult.data).isValid() && (
                <Moment format="YYYY-MM-DD" globallocale="sv">
                  {lastUpdatedVtrResult.data}
                </Moment>
              )}
            </Typography>
          )}
        </>
        ) : (
          <>
            <Grid container direction="row">
              <Grid item xs={12} md={12} lg={12}>
                <LoadingHeader />
                <LoadingTabs />
              </Grid>
            </Grid>
          </>
      )}
      </Container>
    </Box>
  )
}
export default VehicleDetails
